import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {environment} from '../../../environments/environment';
import { ReleaseOfUnwantedCnaeAuditModel, ReleaseOfUnwantedCnaeCreateModel, ReleaseOfUnwantedCnaeUpdateModel, ReleaseOfUnwantedCnaeUpdateStatusModel, SearchReleaseOfUnwantedCnaeModel } from '../models/releaseOfUnwantedCnae.models';

@Injectable({
  providedIn: 'root'
})
export class ReleaseOfUnwantedCnaeService {

  constructor(readonly http: HttpClient) { }

  save(data: ReleaseOfUnwantedCnaeCreateModel): Observable<any> {
    return this.http.post(`${environment.apiUrls.releaseOfUnwantedCnae}`, data);
  }

  getAllPageable(filtro: SearchReleaseOfUnwantedCnaeModel): Observable<any> {
    return this.http.get(`${environment.apiUrls.releaseOfUnwantedCnae}/pageable?page=${filtro.pageNumber}&size=${filtro.size}&institution=${filtro.institution}&serviceContract=${filtro.serviceContract}`);
  }

  update(data: ReleaseOfUnwantedCnaeUpdateModel): Observable<any> {
    return this.http.post(`${environment.apiUrls.releaseOfUnwantedCnae}/update`, data);
  }

  updateStatus(data: ReleaseOfUnwantedCnaeUpdateStatusModel): Observable<any> {
    return this.http.post(`${environment.apiUrls.releaseOfUnwantedCnae}/update-status`, data);
  }

  getAudit(id: number): Observable<ReleaseOfUnwantedCnaeAuditModel[]> {
    return this.http.get<ReleaseOfUnwantedCnaeAuditModel[]>(`${environment.apiUrls.releaseOfUnwantedCnae}/${id}/audit`);
  }
}
